<div class="mb-2">
  <div class="flex" [ngClass]="centered() ? 'justify-center text-center' : 'justify-between'">
    <h2 class="text-lg font-medium" [ngClass]="centered() ? 'text-center' : ''"><ng-content/></h2>
  </div>
</div>
